import {
  GenerateSharedLinkBody,
  GenerateSharedLinkResponse,
  GetDrugDetailsResponse,
  GetSharedLinkDetailsResponse,
  NewsItemDetailsType,
  SearchNewsForm,
  SharedLinkDetailsData,
} from '../../interfaces/api/tabs';
import {api} from '../api';
import http from '../http';
import {store} from '../../redux/store';
import Config from 'react-native-config';
import {GetPublisherResponse} from '../../interfaces/api/content/news';
import {HttpResponse} from '../../interfaces/api/http';
import axios from 'axios';

export const news = {
  getNewsDetails: (
    id: number,
    isRecommendations?: boolean,
  ): Promise<HttpResponse<NewsItemDetailsType>> =>
    new Promise((resolve, reject) => {
      const url = `${
        isRecommendations
          ? api.news.recommendationsDetails
          : api.news.newsDetails
      }/${id}`;
      http
        .get<NewsItemDetailsType>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getDrugDetails: (
    id: string,
    isDiseases?: boolean,
  ): Promise<HttpResponse<GetDrugDetailsResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${
        isDiseases ? api.news.diseasesDetails : api.news.drugDetails
      }/${id}`;
      http
        .get<GetDrugDetailsResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getPublishersByLetter: ({
    tabId,
    page,
    pageSize,
    ...filters
  }: SearchNewsForm): Promise<HttpResponse<GetPublisherResponse>> =>
    new Promise((resolve, reject) => {
      const {specialty_id, email} = store.getState().auth?.currentUser || {};
      if (!tabId || !specialty_id) {
        throw new Error('tab id and subspecialty id are required');
      }
      const params = new URLSearchParams();
      params.append('tab_id', tabId.toString());
      params.append('specialty_id', specialty_id.toString());
      if (email?.trim().toLowerCase() === Config.APPLE_EMAIL) {
        params.append('show', '1');
      }
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, String(filters[key]));
        }
      });

      if (page) {
        params.append('page', page.toString());
        params.append('pageSize', (pageSize || 10).toString());
      }

      const url = `${api.news.publishers}?${params.toString()}`;
      http
        .get<GetPublisherResponse>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  generateSharedLink: (
    body: GenerateSharedLinkBody,
  ): Promise<HttpResponse<GenerateSharedLinkResponse>> =>
    new Promise((resolve, reject) => {
      const url = `${api.news.sharedNews}`;
      http
        .post<GenerateSharedLinkResponse>(url, body)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
  getSharedLinkDetails: (
    token: string,
  ): Promise<HttpResponse<SharedLinkDetailsData>> =>
    new Promise((resolve, reject) => {
      const url = `${api.news.sharedNews}/${token}`;
      http
        .get<SharedLinkDetailsData>(url)
        .then(res => resolve(res))
        .catch(e => reject(e));
    }),
};
